import { render, staticRenderFns } from "./courseDetailsPicture.vue?vue&type=template&id=878a62aa&"
import script from "./courseDetailsPicture.vue?vue&type=script&lang=js&"
export * from "./courseDetailsPicture.vue?vue&type=script&lang=js&"
import style0 from "./courseDetailsPicture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports